import { TimeRangePreset } from "@volca/ui/components/ui/time-range-picker";
import { dayjs } from "@/core/utils/date";

const getLastFourWeeks = () => {
  const weeks = [];

  // Get last Monday (or today if today is Monday)
  const today = dayjs();
  const currentDay = today.day();
  const daysToLastMonday = currentDay === 0 ? 6 : currentDay - 1;
  const lastMonday = today.subtract(daysToLastMonday, "days").startOf("day");

  for (let i = 0; i < 4; i++) {
    const weekStart = lastMonday.subtract(i * 7, "days");
    const weekEnd = weekStart.add(6, "days").endOf("day");

    const startMonth = weekStart.format("MMM");
    const endMonth = weekEnd.format("MMM");

    weeks.push({
      label: `${startMonth} ${weekStart.date()}–${endMonth} ${weekEnd.date()}`,
      value: `week_${i + 1}`,
      startDate: weekStart.toDate(),
      endDate: weekEnd.toDate(),
    });
  }

  return weeks;
};

const getLastMonthLabel = () => {
  const lastMonth = dayjs().subtract(1, "month");
  const monthName = lastMonth.format("MMM");
  return `Last month (${monthName})`;
};

const WEEKLY_PRESETS = getLastFourWeeks().map((week) => ({
  label: week.label,
  getValue: () => ({
    from: week.startDate,
    to: week.endDate,
    label: week.label,
  }),
}));

export const USER_REPORTING_PRESETS: TimeRangePreset[] = [
  {
    label: "Today",
    getValue: () => ({
      from: dayjs().startOf("day").toDate(),
      to: dayjs().endOf("day").toDate(),
      label: "Today",
    }),
  },
  {
    label: "Last 30 days",
    getValue: () => ({
      from: dayjs().subtract(30, "days").toDate(),
      to: dayjs().toDate(),
      label: "Last 30 days",
    }),
  },
  {
    label: getLastMonthLabel(),
    getValue: () => ({
      from: dayjs().subtract(1, "month").startOf("month").toDate(),
      to: dayjs().subtract(1, "month").endOf("month").toDate(),
      label: getLastMonthLabel(),
    }),
  },
  {
    label: "All time",
    getValue: () => ({
      from: dayjs("2020-01-01").toDate(),
      to: dayjs().toDate(),
      label: "All time",
    }),
  },
  ...WEEKLY_PRESETS,
];
